import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {ExternalForm, ExternalFormConfig} from "./external_form";

export const externalFormLoader = function (options = {}) {
    componentLoader(componentConfig(ExternalForm, ExternalFormConfig.componentTypeKey, ExternalFormConfig.baseHtmlClass), options);
};
